import React, { useEffect, useState } from 'react';
import './ContactBadge.css';

// A LAST-CONTACT HEARTBEAT: icon, short label, and how long ago the other end last called.
//
// ONE COMPONENT FOR EVERY HEARTBEAT. The sync project page (OXI enqueue / dequeue) and the integration
// designer (HTTP push / pull, V489) show the same fact the same way; built twice they would disagree on
// what "red" means within a week.
//
// RED ONLY WHEN THERE HAS NEVER BEEN CONTACT. Once anything has been seen it stays green and the age says
// how stale it is — same rule the sync page has always used.
//
// `lastContactMs` is epoch milliseconds (null = never). The badge counts forward from it on its own
// one-second tick, so the age moves between the caller's refreshes.

export const formatContactAge = (sec) => {
    if (sec == null) return 'never';
    if (sec < 60) return `${sec}s ago`;
    if (sec < 3600) return `${Math.floor(sec / 60)}m ago`;
    if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
    return `${Math.floor(sec / 86400)}d ago`;
};

const ContactBadge = ({ icon: Icon, label, title, lastContactMs }) => {
    const [, setTick] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setTick(t => t + 1), 1000);
        return () => clearInterval(id);
    }, []);

    const age = lastContactMs == null ? null : Math.max(0, Math.floor((Date.now() - Number(lastContactMs)) / 1000));
    return (
        <span className="sync-dot" title={`${title || label}: last contact ${formatContactAge(age)}`}>
            {Icon && <Icon className="sync-dot-icon" size={13} strokeWidth={2.25} />}
            <span className="sync-dot-label">{label}</span>
            <span className={`sync-dot-state ${age != null ? 'is-live' : 'is-never'}`}>
                <span className="sync-dot-led" />
                {formatContactAge(age)}
            </span>
        </span>
    );
};

export default ContactBadge;
